import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="21" height="21" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M10.5 5.677c.55 0 1 .45 1 1v4c0 .55-.45 1-1 1s-1-.45-1-1v-4c0-.55.45-1 1-1zm-.01-5c-5.52 0-9.99 4.48-9.99 10s4.47 10 9.99 10c5.53 0 10.01-4.48 10.01-10s-4.48-10-10.01-10zm.01 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm1-3h-2v-2h2v2z" fill="#444" /></svg>;